import { Component, createSignal, onMount } from 'solid-js';
import { getOrSetAsync } from './API';

type LoadHtmlProps = {
    url: string;
}

export const LoadHtml : Component<LoadHtmlProps> = (props) => {
    const [html, setHtml] = createSignal<string>();
    const getHtml = async (url: string) => {
        const html = await getOrSetAsync("load-html:" + url, async () => {
            const response = await fetch(url);
            const html = await response.text();
            return html;
        });
        return html;
    };
    onMount(async () => {
        const data = await getHtml(props.url);
        setHtml(data);
    });
return (
<div innerHTML={html()}></div>);
}